<template>
  <div class="flex flex-column align-items-center justify-content-center">
    <div
      id="contentList"
      class="align-items-center justify-content-center"
      style="display: flex; margin-bottom: 25px"
    >
      <ul style="text-align: left">
        <li v-for="panelRef in panelRefs" v-bind:key="panelRef" style="margin: 6px 2px">
          <a class="fakeLink" @click="scrollTo(panelRef)">{{ panelRef.header }}</a>
        </li>
      </ul>
    </div>
    <div
      class="align-items-start justify-content-start"
      style="width: 100%; max-width: 1000px"
    >
      <Panel
        v-if="loggedIn"
        ref="panel1"
        header="Ich finde hier keine passende Antwort oder ausreichende Informationen! Was kann ich tun?"
      >
        <div class="flex flex-column align-items-center justify-content-center">
          <div class="flex align-items-center justify-content-center">
            <h3>Schreib uns eine Nachricht über dein Postfach!</h3>
          </div>
          <div style="text-align: left; max-width: 700px">
            Im Postfach erreichst du unter „Neue Nachricht" den Spielleiter, den
            Webmaster und den Programmierer. Als Mannschaftsvertreter kannst du dort
            außerdem den Staffelleiter deiner Liga, die Mannschaftsvertreter deiner Liga
            und die Mannschaften deines Vereins anschreiben. Die Antwort landet wieder in
            deinem Postfach, und auf Wunsch bekommst du eine E-Mail, sobald eine neue
            Nachricht für dich vorliegt. Wie das Postfach im Einzelnen funktioniert, steht
            unter
            <a class="fakeLink" @click="findAndScrollTo('panelPostfach')"
              >„Wie arbeite ich mit meinem Postfach?"</a
            >.
          </div>
          <div
            class="flex align-items-center justify-content-center"
            style="margin-top: 20px"
          >
            <Button
              label="Nachricht schreiben"
              icon="pi pi-envelope"
              @click="routeToInbox()"
            />
          </div>
        </div>
      </Panel>
      <Panel ref="panel2" header="Wie ist das Programm grundsätzlich aufgebaut?">
        <div class="flex flex-column align-items-center justify-content-center">
          <h2>Hauptmenü</h2>
          <table>
            <tr style="text-align: left">
              <td>
                <i class="pi pi-fw pi-home" style="font-size: 38px; margin: 10px"></i>
              </td>
              <td width="110px">Home</td>
              <td>
                Zurück zur Startseite mit der Mannschaftsauswahl und der
                Spieltagsübersicht.
              </td>
            </tr>
            <tr style="text-align: left">
              <td>
                <i class="pi pi-fw pi-envelope" style="font-size: 38px; margin: 10px"></i>
              </td>
              <td>Postfach</td>
              <td>
                Öffnet dein Postfach mit Nachrichten sowie Verlegungs- und
                Heimrechtanfragen. Ungelesenes ist mit einer Zahl markiert.
              </td>
            </tr>
            <tr style="text-align: left">
              <td>
                <i class="pi pi-fw pi-bars" style="font-size: 38px; margin: 10px"></i>
              </td>
              <td width="110px">Seitenmenü</td>
              <td>
                Öffnet das Seitenmenü, welches Funktionen enthält, die nicht regelmäßig
                benötigt werden.
              </td>
            </tr>
            <tr style="text-align: left; margin: 10px">
              <td><i class="pi pi-fw pi-cog" style="font-size: 38px"></i></td>
              <td>Einstellungen</td>
              <td>
                Öffnet die Seite für Benutzereinstellungen, aktuell einzige Unterpunkt ist
                die Anpassung der Zugangsdaten (Benutzername, Passwort)
              </td>
            </tr>
            <tr style="text-align: left; margin: 10px">
              <td><i class="pi pi-fw pi-question-circle" style="font-size: 38px"></i></td>
              <td>Hilfe</td>
              <td>Öffnet diese Hilfeseite</td>
            </tr>
            <tr style="text-align: left; margin: 10px">
              <td><i class="pi pi-fw pi-sign-out" style="font-size: 38px"></i></td>
              <td>Abmelden</td>
              <td>Meldet den aktuellen Benutzer ab und leitet auf die Anmeldeseite</td>
            </tr>
            <tr style="text-align: left; margin: 10px">
              <td><i class="pi pi-fw pi-pencil" style="font-size: 38px"></i></td>
              <td>Bearbeiten</td>
              <td>
                Wechselt in den Bearbeitungsmodus um den angezeigten Datensatz zu
                bearbeiten.
              </td>
            </tr>
            <tr style="text-align: left; margin: 10px">
              <td><i class="pi pi-fw pi-save" style="font-size: 38px"></i></td>
              <td>Speichern</td>
              <td>
                Speichert die getätigten Änderungen an einem Datensatz. Nur im
                Bearbeitungsmodus vorhanden
              </td>
            </tr>
            <tr style="text-align: left; margin: 10px">
              <td><i class="pi pi-fw pi-times" style="font-size: 38px"></i></td>
              <td>Abbrechen</td>
              <td>
                Verwirft die getätigten Änderungen an einem Datensatz. Nur im
                Bearbeitungsmodus vorhanden
              </td>
            </tr>
            <tr style="text-align: left; margin: 10px">
              <td><i class="pi pi-fw pi-arrow-left" style="font-size: 38px"></i></td>
              <td>Zurück</td>
              <td>Rückkehr zur vorhergehenden Seite.</td>
            </tr>
            <tr style="text-align: left; margin: 10px">
              <td><i class="pi pi-fw pi-check-square" style="font-size: 38px"></i></td>
              <td>Abschließen</td>
              <td>
                Beenden eines mehrstufigen Bearbeitungsprozess, zum Beispiel der
                Eintragung eines Spielergebnisses
              </td>
            </tr>
            <tr style="text-align: left; margin: 10px">
              <td>
                <i class="pi pi-fw pi-exclamation-triangle" style="font-size: 38px"></i>
              </td>
              <td>Hinweisen</td>
              <td>
                Beanstandet als Gast einen Spielbericht und informiert den Spielleiter.
                Nur nach einem Spiel sichtbar.
              </td>
            </tr>
          </table>
          <h2>Mannschaft</h2>
          <span
            >Der blaue Balken oben zeigt die Mannschaften, für die du Vertretungsrechte
            hast. Vertrittst du mehrere, wechselst du per Klick zwischen ihnen; bei nur
            einer ist diese fest vorausgewählt.</span
          >
          <h2>Untermenü</h2>
          <img src="./images/menu_teamvertreter.png" style="width: 300px" />
          <table>
            <tr style="text-align: left">
              <td style="border-bottom: 1px solid #ddd">
                <i class="pi pi-fw pi-calendar" style="font-size: 34px; margin: 5px"></i>
              </td>
              <td style="border-bottom: 1px solid #ddd">Spieltage</td>
              <td style="border-bottom: 1px solid #ddd">
                Spieltagsübersicht der Mannschaft: Spiele einsehen, eintragen, verlegen.
                Siehe auch:
                <a class="fakeLink" @click="findAndScrollTo('panel3')"
                  >„Wie kann ich ein Spielergebnis eintragen?"</a
                >
              </td>
            </tr>
            <tr style="text-align: left">
              <td style="border-bottom: 1px solid #ddd">
                <i class="pi pi-fw pi-users" style="font-size: 34px; margin: 5px"></i>
              </td>
              <td style="border-bottom: 1px solid #ddd">Mannschaft</td>
              <td style="border-bottom: 1px solid #ddd">
                Spielerliste der Mannschaft: Spieler hinzufügen oder abmelden. Siehe auch:
                <a class="fakeLink" @click="findAndScrollTo('panel8')"
                  >„…neuen Spieler hinzufügen?"</a
                >
                und
                <a class="fakeLink" @click="findAndScrollTo('panel10')"
                  >„…einen Spieler abmelden?"</a
                >
              </td>
            </tr>
            <tr style="text-align: left">
              <td style="border-bottom: 1px solid #ddd">
                <i class="pi pi-fw pi-sitemap" style="font-size: 34px; margin: 5px"></i>
              </td>
              <td style="border-bottom: 1px solid #ddd">Pokal</td>
              <td style="border-bottom: 1px solid #ddd">
                Nur wenn die Mannschaft am Pokal teilnimmt. Siehe auch:
                <a class="fakeLink" @click="findAndScrollTo('panelPokal')"
                  >„Wo finde ich unsere Pokalspiele?"</a
                >
              </td>
            </tr>
            <tr style="text-align: left">
              <td style="border-bottom: 1px solid #ddd">
                <i
                  class="pi pi-fw pi-ellipsis-v"
                  style="font-size: 34px; margin: 5px"
                ></i>
              </td>
              <td style="border-bottom: 1px solid #ddd">Weiteres</td>
              <td style="border-bottom: 1px solid #ddd">
                Klappt auf zu
                <b>Vertretung</b>
                <i class="pi pi-fw pi-user"></i>,
                <b>Spielort</b>
                <i class="pi pi-fw pi-compass"></i>
                und
                <b>3K-Einstellungen</b>. Siehe auch:
                <a class="fakeLink" @click="findAndScrollTo('panelVertretung')"
                  >„…Vertretung ändern?"</a
                >,
                <a class="fakeLink" @click="findAndScrollTo('panelSpielort')"
                  >„…Spielort anpassen?"</a
                >
                ,
                <a class="fakeLink" @click="findAndScrollTo('panel14')"
                  >„…3K-Account verbinden?"</a
                >
                und
                <a class="fakeLink" @click="findAndScrollTo('panel2kSpieler')"
                  >„…Spieler der Gegner nach 3K?"</a
                >
              </td>
            </tr>
          </table>
        </div>
      </Panel>
      <Panel ref="panel3" header="Wie kann ich ein Spielergebnis eintragen?">
        <div class="flex flex-column align-items-center justify-content-center">
          <ol style="text-align: left">
            <li style="vertical-align: middle">
              <h3 style="text-decoration: underline">
                Navigation zur Spieltagsübersicht über den Untermenüpunkt
                <i
                  class="pi pi-fw pi-calendar"
                  style="font-size: 28px; vertical-align: middle"
                ></i>
              </h3>
            </li>

            <li>
              <h3 style="text-decoration: underline">
                Auswahl des Spieltags des einzutragenden Spiels mit Hilfe der
                Spieltagsauswahl<br />
              </h3>
              <Paginator
                v-model:first="alibiIndex"
                :rows="1"
                :pageLinkSize="22"
                template="PageLinks"
                :totalRecords="22"
              >
              </Paginator>
            </li>
            <li>
              <h3 style="text-decoration: underline">
                Auswahl des Spiels durch Klick auf den Bearbeiten-Button
                <Button
                  style="margin: 2px 2px; vertical-align: middle"
                  icon="pi pi-pencil"
                  v-tooltip.top="'Editieren'"
                  class="p-button-rounded p-button-warning mb2"
                />
              </h3>
              <Message
                severity="warn"
                :closable="false"
                style="margin: 0px; margin-bottom: 10px"
              >
                Achtung: Es können nur Heimspiele bearbeitet werden, die sich noch nicht
                im Status „Gespielt" befinden und deren Spieldatum dem heutigen Datum
                entspricht oder deren Spieldatum in der Vergangenheit liegt. Weitere
                Informationen unter
                <a class="fakeLink" @click="findAndScrollTo('panelAblauf')"
                  >„Wie ist eigentlich der genaue Ablauf einer Spielverarbeitung?"</a
                >
              </Message>
            </li>
            <li>
              <h3 style="text-decoration: underline">
                Eingabe der Ergebnisse des Spiels
              </h3>

              <img src="./images/spielerfassung.png" style="width: 100%" />
              Pro Satz die Spieler aufstellen und das Ergebnis eintragen; wie das genau
              geht, steht unter
              <a class="fakeLink" @click="findAndScrollTo('panelAufstellung')"
                >„Wie stelle ich die Spieler auf und trage die Satzergebnisse ein?"</a
              >. Besondere Würfe (180er, HighFinishes, ShortLegs) trägst du über
              <a class="fakeLink" @click="findAndScrollTo('panelHighlights')"
                >„Wie trage ich Highlights ein?"</a
              >
              ein.
              <Message severity="info" :closable="false" style="margin: 0px">
                Die eingetragenen Daten werden sofort gespeichert, es ist keine weitere
                Benutzeraktion hierzu erforderlich.
              </Message>
            </li>
            <li>
              <h3 style="text-decoration: underline">
                Hochladen des Fotos vom Spielbericht, siehe
                <a class="fakeLink" @click="findAndScrollTo('panel4')"
                  >"Wie kann ich ein Bild des Spielergebnisses hochladen?"</a
                >
              </h3>
            </li>
            <li>
              <h3 style="text-decoration: underline">
                Eintragung des Spiels abschließen
              </h3>
              Wenn alle nötigen Informationen im Spielergebnis hinterlegt sind und ein
              Bild hochgeladen wurde, kann die Eintragung durch Klick auf die Schaltfläche
              "Abschließen"
              <i
                class="pi pi-fw pi-check-square"
                style="font-size: 38px; vertical-align: middle"
              ></i>
              im Hauptmenü beendet werden. Vorher ist diese Schaltfläche nicht sichtbar.
              Nach dem Klick auf diese ändert sich der Status des Spiels auf "In
              Bestätigung durch Gast"
              <Message severity="info" :closable="false" style="margin: 10px 0px">
                Fehlt noch etwas, zeigt das Programm es an drei Stellen: der Statushinweis
                über dem Spielbericht nennt den Grund („Es fehlen noch Ergebnisse…",
                „Es wurde noch kein Bild des Spielberichts hochgeladen."), die Reiter
                heißen <b>Ergebnis *</b> bzw. <b>Bild *</b> statt „Ergebnis" und „Bild",
                und jeder betroffene Block trägt hinter seiner Überschrift den Zusatz
                <b>(unvollständig)</b>. Erst wenn beide Sternchen weg sind, erscheint der
                Haken zum Abschließen.
              </Message>
              <Message severity="warn" :closable="false" style="margin: 10px 0px">
                Danach ist sind keine Änderungen mehr an den Ergebnissen oder dem Bild
                möglich. Falls danach Änderungen nachgetragen werden sollen, kann dies nur
                über den Spielleiter erfolgen. Siehe auch:
                <a class="fakeLink" @click="findAndScrollTo('panel5')"
                  >"Wie kann ich dem Spielleiter einen Hinweis zu einem unserer Spiele
                  hinterlassen?"</a
                >
              </Message>
            </li>
          </ol>
        </div>
      </Panel>
      <Panel
        ref="panelAufstellung"
        header="Wie stelle ich die Spieler auf und trage die Satzergebnisse ein?"
      >
        <div class="flex flex-column align-items-center justify-content-center">
          <ol style="text-align: left">
            <li>
              <h4>Spieler aufstellen</h4>
              Im Bearbeitungsmodus unter jedem Satz auf
              <Button
                label="Spieler wählen"
                style="
                  padding: 2px 8px;
                  background-color: #1c80cf;
                  vertical-align: middle;
                "
              />
              klicken, im Dialog „Spielerauswahl" den Namen wählen und mit
              <Button label="Fertig" style="vertical-align: middle" />
              bestätigen. Schon eingesetzte Spieler stehen nicht mehr zur Auswahl.
              <Message severity="warn" :closable="false" style="margin: 8px 0px">
                Die Auswahl wird sofort gespeichert – „Abbrechen" hilft nach dem Antippen
                eines Namens nicht mehr. Die Aufstellung beider Mannschaften trägt die
                Heim-Mannschaft ein.
              </Message>
            </li>
            <li>
              <h4>Satzergebnis eintragen</h4>
              Auf den Ergebnis-Button in der Mitte des Satzes klicken und das Ergebnis
              erfassen – je nach Einstellung mit Schieberegler oder Auswahlknöpfen, siehe
              <a class="fakeLink" @click="findAndScrollTo('panelErgebnismodus')"
                >„Wie stelle ich die Art der Ergebniseingabe um?"</a
              >. Mit
              <Button label="Fertig" style="vertical-align: middle" />
              wird das Ergebnis übernommen.
            </li>
            <li>
              <h4>Falsch eingetragenes Satzergebnis korrigieren</h4>
              Den Ergebnis-Button des Satzes erneut anklicken und im Dialog entweder das
              richtige Ergebnis einstellen oder mit
              <Button label="Löschen" style="vertical-align: middle" />
              das Ergebnis wieder entfernen. Der Satz steht danach wieder auf „Zu
              spielen".
            </li>
            <li>
              <h4>Kampflosen Satz (Freilos) erfassen</h4>
              In der Spielerauswahl den Eintrag
              <b>„------ FREILOS ------"</b>
              wählen. Der Satz wird automatisch mit der Höchstpunktzahl für die
              anwesende Seite gewertet, alle Plätze der freigelosten Seite werden auf „-"
              gesetzt.
              <Message severity="info" :closable="false" style="margin: 8px 0px">
                Rückgängig: auf der Freilos-Seite wieder einen echten Spieler wählen –
                dann muss das Satzergebnis neu erfasst werden.
              </Message>
            </li>
          </ol>
          <Message severity="warn" :closable="false" style="margin: 0px">
            Halb ausgefüllte Sätze (Spieler ohne Ergebnis oder umgekehrt) werden beim
            Speichern verworfen und verschwinden wieder.
          </Message>
        </div>
      </Panel>
      <Panel
        ref="panelHighlights"
        header="Wie trage ich Highlights ein (180er, HighFinish, ShortLeg)?"
      >
        <div class="flex flex-column align-items-center justify-content-center">
          <ul style="text-align: left">
            <li>
              Sobald ein echter Spieler im Satz steht, erscheint unter ihm der
              Highlight-Button (zeigt z.&nbsp;B. „HS: 180 (2), HF: 120, SL: 15"). Ein
              Klick öffnet den Dialog „Highlights" mit drei Bereichen:
              <ul>
                <li><b>HighScores</b> (≥ 171, also 171–180)</li>
                <li><b>HighFinishes</b> (100–170)</li>
                <li><b>ShortLegs</b> (9–18 Darts)</li>
              </ul>
            </li>
            <li>
              Wert ins Eingabefeld tippen und mit
              <Button
                icon="pi pi-plus"
                style="width: 28px; vertical-align: middle"
              />
              hinzufügen. Eine bestehende Zeile erhöhst oder verringerst du mit
              <Button
                icon="pi pi-plus"
                style="width: 28px; vertical-align: middle"
              />
              /
              <Button
                icon="pi pi-minus"
                style="width: 28px; vertical-align: middle"
              />
              – die Zahl in Klammern ist die Anzahl.
            </li>
            <li>
              Mit
              <Button label="Fertig" style="vertical-align: middle" />
              speichern,
              <Button label="Abbrechen" style="vertical-align: middle" />
              verwirft die Änderungen dieses Dialogs.
            </li>
          </ul>
          <Message severity="info" :closable="false" style="margin: 0px">
            Ein ShortLeg im Doppel zählt für beide Spieler – nur einmal eintragen.
            Ungültige Werte werden ohne Meldung verworfen, leere Zeilen (0) beim Schließen
            entfernt.
          </Message>
        </div>
      </Panel>
      <Panel ref="panel4" header="Wie kann ich ein Bild des Spielergebnisses hochladen?">
        <div class="flex flex-column align-items-center justify-content-center">
          <ol style="text-align: left">
            <li>
              <h3>Im Bearbeitungsmodus des Spiels auf den Reiter Bild klicken</h3>
            </li>
            <li>
              <h3>
                Dort auf
                <Button
                  icon="pi pi-plus"
                  label="Bild auswählen und hochladen"
                  style="vertical-align: middle"
                />
                bzw.
                <Button
                  icon="pi pi-plus"
                  label="Anderes Bild auswählen und hochladen"
                  style="vertical-align: middle"
                />
                klicken.
              </h3>
            </li>
            <li>
              <h3>
                Im erscheinenden Dateiauswahl-Dialog das entsprechende Bild auswählen und
                bestätigen. Das Bild wird dann hochgeladen.
              </h3>
              <Message severity="warn" :closable="false" style="margin: 10px 0px">
                Hinweis: Es sind nur noch Bildformate, wie JPG, JPEG, PNG, usw. erlaubt.
                PDFs und andere Dokumente werden abgelehnt.
              </Message>
            </li>
            <li>
              <h3>
                Das Bild kann über die beiden Schaltflächen
                <Button
                  v-tooltip.bottom="'Bild gegen den Uhrzeigersinn drehen'"
                  icon="pi pi-replay"
                  style="margin: 5px 3px; vertical-align: middle"
                />
                <Button
                  v-tooltip.bottom="'Bild im Uhrzeigersinn drehen'"
                  icon="pi pi-refresh"
                  style="margin: 5px 3px; vertical-align: middle"
                />
                gegen bzw. im Uhrzeigersinn gedreht werden.
                <Message severity="info" :closable="false" style="margin: 0px">
                  Die Änderungen an dem Bild sofort gespeichert, es ist keine weitere
                  Benutzeraktion hierzu erforderlich.
                </Message>
              </h3>
            </li>
          </ol>
        </div>
      </Panel>
      <Panel
        ref="panel5"
        header="Wie kann ich dem Spielleiter einen Hinweis zu einem unserer Spiele hinterlassen?"
      >
        <div class="flex flex-column align-items-center justify-content-center">
          <ul style="text-align: left">
            <li>
              In der Detailsansicht des Spiels auf den Reiter Bemerkungen und danach auf
              <Button label="Bemerkung hinzufügen" style="vertical-align: middle" />
              klicken.<br />
              Danach kann im freien Bereich des Dialogs ein Text eingeben werden und
              dieser mit einem Klick auf
              <Button label="Eintragen" style="vertical-align: middle" />
              gespeichert oder mit einem Klick auf
              <Button label="Abbrechen" style="vertical-align: middle" />
              verworfen werden.
              <Message severity="warn" :closable="false" style="margin: 0px">
                Ein nachträgliches Editieren der Bemerkung ist nicht möglich.
              </Message>
            </li>
          </ul>
        </div>
      </Panel>
      <Panel ref="panel6" header="Was kann ich als Gast nach einem Spiel tun?">
        <ul style="text-align: left">
          Der Teamvertreter/Kapitän hat nach der erfolgten Eingabe durch die
          Heim-Mannschaft die Möglichkeit, den Spielbericht zu verifizieren und diesen
          dann mit einem Klick auf
          <i
            class="pi pi-fw pi-check-square"
            style="font-size: 38px; margin: 5px; vertical-align: middle"
          />
          zu bestätigen oder mit einem Klick auf
          <i
            class="pi pi-fw pi-exclamation-triangle"
            style="font-size: 38px; margin: 5px; vertical-align: middle"
          />
          dem Spielleiter einen Hinweis über fehlende oder fehlerhafte Eintragungen im
          Spielbericht hinterlegen. Der Hinweis wird dann in den Bemerkungen hinterlegt
          und der Spielstatus wird auf "In Kontrolle durch Spielleiter" gesetzt. Der
          Spielleiter wird darauf hin automatisch informiert, d.h. es ist keine weitere
          Benachrichtigung nötig.
        </ul>
      </Panel>

      <Panel ref="panel7" header="Warum kann ich manche Spiele nicht (mehr) editieren?">
        <h4>Dies kann mehrere Ursachen haben:</h4>
        <ul style="text-align: left">
          <li>Nur die Heim-Mannschaft kann ein Spielergebnis eintragen</li>
          <li>Spiele können nur an oder nach dem Spieltermin eingetragen werden</li>
          <li>
            Nach dem Abschluss des Spielberichts ist eine nachträglich editieren nicht
            mehr möglich.
          </li>
        </ul>
      </Panel>

      <Panel
        ref="panelAblauf"
        header="Wie ist eigentlich der genaue Ablauf einer Spielverarbeitung?"
      >
        <div class="flex flex-column align-items-center justify-content-center">
          Der Spielstatus (Spalte „Spielstatus" in der Spieltagsübersicht) zeigt, wo ein
          Spiel gerade steht. Der übliche Weg:
          <ol style="text-align: left">
            <li><b>Zu spielen</b> – der Spieltermin ist noch offen.</li>
            <li>
              <b>Noch kein Endergebnis</b> / <b>Noch kein Bild des Endergebnisses</b> –
              die Heim-Mannschaft trägt Ergebnis und Bild ein.
            </li>
            <li>
              <b>In Bestätigung durch Gast</b> – die Heim-Mannschaft hat mit
              <i
                class="pi pi-fw pi-check-square"
                style="font-size: 24px; vertical-align: middle"
              />
              abgeschlossen; jetzt ist der Gast am Zug (siehe
              <a class="fakeLink" @click="findAndScrollTo('panel6')"
                >„Was kann ich als Gast nach einem Spiel tun?"</a
              >).
            </li>
            <li>
              <b>In Kontrolle durch Spielleiter</b> – nur, wenn der Gast beanstandet hat.
              Der Spielleiter entscheidet.
            </li>
            <li><b>Gespielt</b> – das Ergebnis ist endgültig gewertet.</li>
          </ol>
          <span style="text-align: left"
            >Weitere mögliche Status: <b>Verlegt</b> (siehe
            <a class="fakeLink" @click="findAndScrollTo('panel12')"
              >Spielverlegung</a
            >), <b>Änderung beim Gegner angefragt</b> und <b>Keine Wertung</b>.</span
          >
          <Message severity="warn" :closable="false" style="margin: 10px 0px">
            Abgabefrist: Der Spielbericht muss bis zum <b>Montag 18:00 Uhr</b> nach dem
            Spieltag abgeschlossen sein (bei verlegten Spielen: Spieltermin + 2 Tage).
            Danach vergibt das Programm automatisch Strafpunkte an die Heim-Mannschaft –
            beim ersten Vorfall einen, bei jedem weiteren einen mehr – und vermerkt das in
            den Spielleiter-Bemerkungen.
          </Message>
        </div>
      </Panel>

      <Panel
        ref="panel8"
        header="Wie kann ich einen neuen Spieler zu meiner Mannschaft hinzufügen?"
      >
        <div>
          <ul style="text-align: left">
            <li>
              Im Menüpunkt Mannschaft
              <i
                class="pi pi-fw pi-users"
                style="font-size: 38px; vertical-align: middle"
              />
              kann über das Seitenmenü
              <i
                class="pi pi-fw pi-bars"
                style="font-size: 38px; vertical-align: middle"
              />
              und den dortigen Menüpunkt "Spieler zur Mannschaft hinzufügen" ein Spieler
              aus dem Verein, der noch keiner Mannschaft zugewiesen ist, hinzugefügt
              werden.
              <Message severity="info" :closable="false" style="margin: 10px 0px">
                Das Programm importiert jede Stunde die aktuelle Liste der Spieler, die
                beim BWDV gemeldet sind und ordnet sie dem dort eingetragenen Verein zu.
              </Message>
              <Message severity="warn" :closable="false" style="margin: 0px">
                Wenn der Spieler in der BWDV-Liste noch nicht enthalten ist, erscheint er
                auch nicht in der Auswahl für neue Spieler. Von der Anmeldung an den BWDV
                bis zur Eintragung in die Liste dauert es normalerweise einige Tage.
              </Message>
            </li>
          </ul>
        </div>
      </Panel>
      <Panel ref="panel10" header="Wie kann ich einen Spieler abmelden?">
        <div>
          <ul style="text-align: left">
            <li>
              Im Menüpunkt Mannschaft
              <i
                class="pi pi-fw pi-users"
                style="font-size: 38px; vertical-align: middle"
              />
              kann durch den Klick auf
              <Button
                style="margin: 2px 2px; vertical-align: middle"
                icon="pi pi-trash"
                v-tooltip.top="'Abmelden'"
                class="p-button-rounded p-button-warning"
              />
              der Spieler abgemeldet werden.<br />
              Wird dies vor der Saison oder vor der Rückrunde durchgeführt, kann der
              Spieler bei einer anderen Mannschaft des Vereins angemeldet werden.
              <Message severity="warn" :closable="false" style="margin: 10px 0px">
                Diese Abmeldung ist keine Abmeldung beim BWDV. Dies muss nach wie vor über
                das entsprechende Formular geschehen.
              </Message>
            </li>
          </ul>
        </div>
      </Panel>
      <Panel
        ref="panelVertretung"
        header="Wie kann ich die Kontaktdaten der Vertretung (Teamvertreter / Kapitän) ändern?"
      >
        <div>
          <ul style="text-align: left">
            <li>
              Im Untermenü
              <i
                class="pi pi-fw pi-ellipsis-v"
                style="font-size: 30px; vertical-align: middle"
              />
              „Weiteres" auf
              <b>Vertretung</b>
              <i class="pi pi-fw pi-user" style="vertical-align: middle" />
              klicken. Mit
              <i
                class="pi pi-fw pi-pencil"
                style="font-size: 30px; vertical-align: middle"
              />
              „Bearbeiten" im Hauptmenü in den Bearbeitungsmodus wechseln, die
              Kontaktdaten anpassen und mit
              <i
                class="pi pi-fw pi-save"
                style="font-size: 30px; vertical-align: middle"
              />
              „Speichern" sichern (oder mit
              <i
                class="pi pi-fw pi-times"
                style="font-size: 30px; vertical-align: middle"
              />
              „Abbrechen" verwerfen).
              <Message severity="info" :closable="false" style="margin: 10px 0px">
                Wechselt die Rolle auf eine andere Person, trage dort deren Daten ein. Wer
                das Programm bedienen darf (Benutzerzugang), legt der Spielleiter fest.
              </Message>
            </li>
          </ul>
        </div>
      </Panel>
      <Panel ref="panelSpielort" header="Wie kann ich den Spielort anpassen?">
        <div>
          <ul style="text-align: left">
            <li>
              Im Untermenü
              <i
                class="pi pi-fw pi-ellipsis-v"
                style="font-size: 30px; vertical-align: middle"
              />
              „Weiteres" auf
              <b>Spielort</b>
              <i class="pi pi-fw pi-compass" style="vertical-align: middle" />
              klicken, mit
              <i
                class="pi pi-fw pi-pencil"
                style="font-size: 30px; vertical-align: middle"
              />
              „Bearbeiten" die Details ändern und mit
              <i
                class="pi pi-fw pi-save"
                style="font-size: 30px; vertical-align: middle"
              />
              „Speichern" sichern.
              <Message severity="warn" :closable="false" style="margin: 10px 0px">
                Die Anschrift des Spielortes (Straße, PLZ und Ort) kann aktuell nur der
                Spielleiter ändern. Bei einem Spielortwechsel oder einer geänderten
                Anschrift bitte den Spielleiter informieren.
              </Message>
            </li>
          </ul>
        </div>
      </Panel>
      <Panel ref="panel11" header="Wie kann ich meine Zugangsdaten ändern?">
        <div>
          <ul style="text-align: left">
            <li>
              Im Hauptmenü auf Einstellungen
              <i
                class="pi pi-fw pi-cog"
                style="font-size: 38px; vertical-align: middle"
              />
              klicken und den Reiter
              <b>Zugangsdaten</b>
              <i class="pi pi-fw pi-sign-in" style="vertical-align: middle" />
              wählen. <br />Dort Benutzername und Passwort anpassen (ein neues Passwort
              braucht mindestens 8 Zeichen) und mit
              <Button label="Ändern" class="mt-2" style="vertical-align: middle" />
              speichern. Nach der Bestätigung des Abfragedialogs mit „Ja" ist eine erneute
              Anmeldung mit den neuen Zugangsdaten nötig.
            </li>
          </ul>
        </div>
      </Panel>
      <Panel
        ref="panelErgebnismodus"
        header="Wie stelle ich die Art der Ergebniseingabe um (Schieberegler oder Auswahlknöpfe)?"
      >
        <div class="flex flex-column align-items-center justify-content-center">
          <span style="text-align: left"
            >Im Hauptmenü auf Einstellungen
            <i class="pi pi-fw pi-cog" style="vertical-align: middle" />
            und dann auf den Reiter
            <b>Ergebniseingabe</b>
            <i class="pi pi-table" style="vertical-align: middle" />. Die gewünschte
            Variante mit
            <Button label="Ändern" style="vertical-align: middle" />
            auswählen – die aktive zeigt „Ausgewählt".</span
          >
          <img
            src="./images/ergebniseingabe.png"
            style="width: 100%; max-width: 460px; margin-top: 10px"
          />
          <Message severity="info" :closable="false" style="margin: 0px">
            Die Einstellung gilt für dich persönlich und wirkt sich beim nächsten Öffnen
            eines Spielberichts aus. Ohne Auswahl ist der Schieberegler voreingestellt.
          </Message>
        </div>
      </Panel>
      <Panel ref="panelPostfach" header="Wie arbeite ich mit meinem Postfach?">
        <div class="flex flex-column align-items-center justify-content-center">
          <span style="text-align: left"
            >Das Postfach öffnest du im Hauptmenü über
            <i class="pi pi-fw pi-envelope" style="vertical-align: middle" />. Dort
            liegen Nachrichten und die Verlegungs- bzw. Heimrechtanfragen. Über
            <b>Empfangen</b> / <b>Gesendet</b> wechselst du zwischen eingegangenen und
            selbst verschickten Nachrichten; rechts steht, wie viele davon ungelesen
            sind.</span
          >
          <img
            src="./images/postfach.png"
            style="width: 100%; max-width: 720px; margin: 10px 0px"
          />
          <ul style="text-align: left">
            <li>
              <b>Nachricht lesen und beantworten:</b> auf die Zeile oder in der Spalte
              „Aktionen" auf
              <Button
                icon="pi pi-search"
                v-tooltip.top="'Nachricht öffnen'"
                class="p-button-rounded"
                style="vertical-align: middle"
              />
              klicken. Im Verlauf unten in das Feld „Antwort schreiben" tippen und mit
              <Button
                label="Antwort senden"
                icon="pi pi-send"
                style="vertical-align: middle"
              />
              abschicken.
            </li>
            <li>
              <b>Gelesen-Status:</b> mit
              <Button
                icon="pi pi-envelope"
                v-tooltip.top="'Als ungelesen markieren'"
                class="p-button-rounded"
                style="vertical-align: middle"
              />
              wieder auf ungelesen setzen, mit
              <Button
                icon="pi pi-check"
                v-tooltip.top="'Als gelesen markieren'"
                class="p-button-rounded"
                style="vertical-align: middle"
              />
              als gelesen markieren.
            </li>
            <li>
              <b>Antwort-Status:</b> die Spalte „Antwort" sagt, von welcher Seite die
              letzte Nachricht stammt: „beantwortet", wenn du zuletzt geschrieben hast,
              sonst „nicht beantwortet". Ein Klick auf die Spaltenüberschrift sortiert
              danach.
            </li>
            <li>
              <b>Neue Nachricht schreiben:</b> auf
              <Button
                label="Neue Nachricht"
                icon="pi pi-pencil"
                style="vertical-align: middle"
              />
              klicken, unter „Empfänger" die Adressaten auswählen, Betreff und Text
              eintragen (max. 1000 Zeichen) und mit
              <Button
                label="Senden"
                icon="pi pi-send"
                style="vertical-align: middle"
              />
              verschicken.
            </li>
            <li>
              Die Empfänger stehen in Gruppen – zum Beispiel „Funktionen" (Spielleiter,
              Webmaster, Programmierer) und „Mannschaftsvertreter" deiner Liga. Über das
              Kästchen an der Gruppenüberschrift wählst du die ganze Gruppe auf einmal
              aus.
            </li>
          </ul>
          <Message severity="info" :closable="false" style="margin: 0px">
            Bei mehreren Empfängern bekommt jeder eine eigene Nachricht und antwortet nur
            an dich – die anderen sehen die Antwort nicht. Damit du nichts übersiehst,
            kannst du dich
            <a class="fakeLink" @click="findAndScrollTo('panelMail')"
              >per E-Mail benachrichtigen lassen</a
            >. Wie du eine Verlegungsanfrage beantwortest, steht unter
            <a class="fakeLink" @click="findAndScrollTo('panel12')"
              >„Wie funktioniert die Spielverlegung?"</a
            >.
          </Message>
        </div>
      </Panel>
      <Panel
        ref="panelMail"
        header="Wie werde ich per E-Mail über neue Nachrichten informiert?"
      >
        <div class="flex flex-column align-items-center justify-content-center">
          <span style="text-align: left"
            >Im Hauptmenü auf Einstellungen
            <i class="pi pi-fw pi-cog" style="vertical-align: middle" />
            und dann auf den Reiter
            <b>E-Mail</b>
            <i class="pi pi-at" style="vertical-align: middle" />. Dort eine
            E-Mail-Adresse eintragen und „E-Mail bei neuen Nachrichten" auf
            <b>Ja</b>
            stellen.</span
          >
          <img
            src="./images/mailbenachrichtigung.png"
            style="width: 100%; max-width: 620px; margin-top: 10px"
          />
          <Message severity="info" :closable="false" style="margin: 0px">
            Neue Nachrichten werden gesammelt und frühestens 30 Minuten nach Eingang
            gebündelt verschickt; bei vielen Nachrichten wächst der Abstand (2, dann 6,
            dann 24 Stunden). Über jede Nachricht wirst du genau einmal informiert.
          </Message>
        </div>
      </Panel>
      <Panel ref="panel12" header="Wie funktioniert die Spielverlegung?">
        <div class="flex flex-column align-items-center justify-content-center">
          Die Spielverlegung läuft in folgenden Schritten ab:
          <ol style="text-align: left">
            <li>
              Erstellen und Versenden einer Verlegungsanfrage an den Vertreter der
              gegnerischen Mannschaft
            </li>
            <li>
              Beantwortung der Anfrage durch den Vertreter der gegnerischen Mannschaft.
              <ul>
                <li>Falls Datum passend ist, wird das Spiel automatisch verlegt</li>
                <li>
                  Falls kein Datum passend ist, bitte mögliche Alternativ-Termine in das
                  Antwort-Textfeld eintragen, damit eine neue Anfrage mit der Alternative
                  gestellt werden kann.
                </li>
              </ul>
            </li>
          </ol>
          <Message
            severity="warn"
            :closable="false"
            style="margin: 0px; margin-bottom: 10px"
          >
            Das Programm identifiziert die Mannschaft, die das Spiel verlegen möchte,
            anhand der Anfrage. Die angefragte Mannschaft sollte also keine Gegenanfrage
            stellen, sondern bei unpassenden Vorschlägen per Antworttext mögliche
            Alternativtermine anbieten.
          </Message>
          <Message
            severity="info"
            :closable="false"
            style="margin: 0px; margin-bottom: 10px"
          >
            Falls keine Einigung erzielt wird, entscheidet die Spielleitung, die die
            Anfragen und Antworten einsehen kann
          </Message>
          <h3>Wie erstelle ich eine Spielverlegungsanfrage?</h3>
          <ol style="text-align: left">
            <li style="vertical-align: middle">
              <h4 style="text-decoration: underline">
                Navigation zur Spieltagsübersicht über den Untermenüpunkt
                <i
                  class="pi pi-fw pi-calendar"
                  style="font-size: 28px; vertical-align: middle"
                ></i>
              </h4>
            </li>

            <li>
              <h4 style="text-decoration: underline">
                Auswahl des Spieltags des einzutragenden Spiels mit Hilfe der
                Spieltagsauswahl<br />
              </h4>
              <Paginator
                v-model:first="alibiIndex"
                :rows="1"
                :pageLinkSize="22"
                template="PageLinks"
                :totalRecords="22"
              >
              </Paginator>
            </li>
            <li>
              <h4 style="text-decoration: underline">
                Auswahl des Spiels durch Klick auf den Verlegen-Button
                <Button
                  style="margin: 2px 2px; vertical-align: middle"
                  icon="pi pi-calendar-times"
                  v-tooltip.top="'Verlegen'"
                  class="p-button-rounded p-button-warning mb2"
                />
              </h4>
              <Message
                severity="warn"
                :closable="false"
                style="margin: 0px; margin-bottom: 10px"
              >
                Achtung: Es können nur Spiele verlegt werden, deren Spieldatum in der
                Zukunft liegt.
              </Message>
            </li>
            <li>
              <h4 style="text-decoration: underline">Anfrage erstellen</h4>
              <ol>
                <li>
                  <h4>Mögliche Datumswerte auswählen</h4>
                  Mit Klick auf die blaue Schaltfläche rechts neben dem Datumsfeld
                  <Calendar
                    showIcon
                    :manualInput="true"
                    :showOnFocus="false"
                    v-model="currentDate"
                    dateFormat="dd.mm.yy"
                    showTime
                    hourFormat="24"
                    :hideOnDateTimeSelect="true"
                    variant="filled"
                    style="margin: 2px 2px; vertical-align: middle"
                  />
                  öffnet sich ein Kalender, mit dessen Hilfe ein Alternativdatum sowie
                  eine Uhrzeit ausgewählt werden kann. Der Kalender schließt sich
                  automatisch mit der Auswahl eines Datums, daher empfiehlt es sich zuerst
                  die Uhrzeit einzustellen, sollte diese nicht dem Standardwert (20 Uhr)
                  enstprechen. Das direkte Editieren des Datums im Textfeld ist ebenfalls
                  möglich.
                </li>
                <li>
                  <h4>Übernahme des Datums in die Vorschlagsliste</h4>
                  Das Datum und die Uhrzeit wird erst mit dem Klick auf
                  <Button
                    style="margin: 2px 2px; vertical-align: middle"
                    label="Datum übernehmen"
                    class="p-button-rounded p-button-warn mb2"
                  />
                  in die darunter liegende Liste an Vorschlägen übernommen.
                </li>
                <li>
                  <h4>Entfernen eines Datums aus der Liste</h4>
                  In der Liste kann ein Datum per Klick auf
                  <Button
                    style="margin: 2px 2px; vertical-align: middle"
                    icon="pi pi-times"
                    v-tooltip.top="'Datum wieder entfernen'"
                    class="p-button-rounded p-button-warn"
                  />
                  rechts neben dem Datum wieder entfernt werden.
                </li>
                <li>
                  <h4>Eingabe einer Begründung</h4>
                  Um dem gegnerischen Mannschaftsvertreter und der Spielleitung eine
                  Begründung für die Spielverlegung nennen zu können, kann und sollte das
                  darunter liegende Textfeld verwendet werden.
                </li>
                <li>
                  <h4>Abschließen der Verlegungsanfrage</h4>
                  Wenn alle alternativen Datumswerte in der Liste eingetragen wurden und
                  die Begründung formuliert ist, kann die Anfrage per Klick auf
                  <Button
                    label="Abschließen"
                    icon="pi pi-check"
                    icon-pos="right"
                    class="p-button-success"
                    style="margin: 2px 2px; vertical-align: middle"
                  />
                  abgeschlossen werden.
                  <Message
                    severity="warn"
                    :closable="false"
                    style="margin: 0px; margin-bottom: 10px"
                  >
                    Achtung: Die Anfrage kann nur abgeschlossen werden, wenn mindestens
                    ein Datum in der Liste der "Vorschlagene Datumswerte" vorhanden ist.
                  </Message>
                </li>
              </ol>
            </li>
          </ol>
          <h3>Wie beantworte ich eine Spielverlegungsanfrage?</h3>
          Anfragen liegen im Postfach, das im Hauptmenü über das Briefumschlag-Symbol
          erreichbar ist. Ungelesene Nachrichten sind dort hervorgehoben.
          <tab-menu
            :model="teamAdminMenuItems"
            :activeIndex="0"
            style="margin-top: 2px; display: flex; justify-content: center"
          >
            <template #item="{ item }">
              <a
                class="p-menuitem-link"
                style="display: flex; flex-direction: column; padding: 5px 6px"
              >
                <span :class="item.icon" style="font-size: 36px"></span>
                <span class="p-menuitem-text" style="margin-top: 8px; font-size: 12px">{{
                  item.label
                }}</span>
              </a>
            </template>
          </tab-menu>
          <ol style="text-align: left">
            <li>
              Mit Klick auf das Postfach öffnet sich die Nachrichtenübersicht
            </li>
            <li>
              Dort auf die entsprechende Anfrage mit Klick auf
              <Button
                style="margin: 2px 2px; vertical-align: middle"
                icon="pi pi-search"
                v-tooltip.top="'Nachricht öffnen'"
                class="p-button-rounded p-button-warn mb2"
              />
              die Nachricht öffnen.
            </li>
            <li>
              In der Nachricht kann dann auf ein passendes Datum <br />
              <Button
                style="margin: 2px 2px; vertical-align: middle"
                label="29.02.2035 20:00 Uhr"
              />
              oder, falls kein Termin passt, auf <br />
              <Button
                style="margin: 2px 2px; vertical-align: middle"
                label="Kein Termin ist passend"
              />
              geklickt werden. <br />
              Bei letzterem im Anschluß in das nun geöffnete Fenster eine Begründung und
              idealerweise Termin-Gegenvorschläge eintragen.
            </li>
          </ol>
        </div>
      </Panel>
      <Panel ref="panel13" header="Wie funktioniert der Heimrechttausch?">
        <div class="flex flex-column align-items-center justify-content-center">
          <h4>
            Der Heimrechttausch funktioniert genau wie die Spielverlegung (
            <a class="fakeLink" @click="findAndScrollTo('panel12')"
              >Wie funktioniert die Spielverlegung?</a
            >) mit zwei Ausnahmen:
            <ol style="text-align: left">
              <ul>
                Die Klickfläche neben dem Spiel sieht so aus:
                <Button
                  style="margin: 2px 2px; vertical-align: middle"
                  icon="pi pi-code"
                  v-tooltip.top="'Heimrecht tauschen'"
                  class="p-button-rounded p-button-warning mb2"
                />
              </ul>
              <ul>
                Statt Datumswerten muss ausgewählt werden, ob der Tausch nur für dieses
                Spiel gilt oder ob das Heimrecht mit dem Rückspiel getauscht werden soll.
              </ul>
            </ol>
          </h4>
        </div>
      </Panel>
      <Panel ref="panelPokal" header="Wo finde ich unsere Pokalspiele?">
        <div class="flex flex-column align-items-center justify-content-center">
          <span style="text-align: left"
            >Nimmt deine Mannschaft am Pokal teil, erscheint im Untermenü der Punkt
            <b>Pokal</b>
            <i class="pi pi-fw pi-sitemap" style="vertical-align: middle" />. Über das
            Auswahlfeld darüber wählst du die Runde.</span
          >
          <img
            src="./images/pokaluebersicht.png"
            style="width: 100%; max-width: 720px; margin: 10px 0px"
          />
          <Message severity="info" :closable="false" style="margin: 0px">
            Ergebniseintragung, Verlegung
            <i class="pi pi-fw pi-calendar-times" style="vertical-align: middle" />
            und Heimrechttausch
            <i class="pi pi-fw pi-code" style="vertical-align: middle" />
            funktionieren wie in der Liga (siehe
            <a class="fakeLink" @click="findAndScrollTo('panel12')">Spielverlegung</a>
            und
            <a class="fakeLink" @click="findAndScrollTo('panel13')">Heimrechttausch</a>).
            Im Pokal ist ein Spiel bereits bei 7 Punkten einer Mannschaft entschieden.
          </Message>
          <Message severity="info" :closable="false" style="margin: 10px 0px 0px 0px">
            Ein Pokalspiel lässt sich bis zu 14 Tage vor oder nach dem Termin der Runde
            verlegen, bei mehrtägigen Runden gerechnet ab deren letztem Tag. Die nächste Runde
            wird trotzdem gleich nach diesem Termin ausgelost: Wer
            gegen den Sieger eines noch offenen Spiels antritt, sieht als Gegner
            „Sieger (X : Y)“. Sobald jenes Spiel ein Ergebnis hat, steht dort die siegreiche
            Mannschaft. Bis dahin lässt sich das Spiel weder verlegen noch das Heimrecht
            tauschen.
          </Message>
        </div>
      </Panel>
      <Panel
        ref="panelSpieler"
        header="Wie sehe ich, welche Spieler gemeldet sind (auch beim Gegner)?"
      >
        <div class="flex flex-column align-items-center justify-content-center">
          <span style="text-align: left"
            >In der Spieltags- oder Pokalübersicht neben einem Mannschaftsnamen auf
            <Button
              icon="pi pi-users"
              v-tooltip.top="'Spieler-Übersicht'"
              class="p-button-rounded p-button-info"
              style="vertical-align: middle"
            />
            klicken. Es öffnet sich die Liste der gemeldeten Spieler dieser
            Mannschaft.</span
          >
          <img
            src="./images/spieleruebersicht.png"
            style="width: 100%; max-width: 340px; margin-top: 10px"
          />
        </div>
      </Panel>
      <Panel
        ref="panel14"
        header="Wie kann ich meinen 3K Vereinsaccount mit dem BDL-Programm verbinden"
      >
        <div class="flex flex-column align-items-center justify-content-center">
          <h4>
            <ol style="text-align: left">
              <ul class="flex flex-column align-items-center justify-content-center">
                <span style="display: block"
                  >Im Menü auf den Bereich "Weiteres", dann auf 3K-Einstellungen
                  klicken.</span
                >
                <img src="./images/2keinstellungen.png" style="width: 200px" />
              </ul>
              <ul class="flex flex-column align-items-center justify-content-center">
                <span style="display: block">
                  Nun muss der 3K-Mandanten-Key aus dem Bereich Kontoübersicht in der
                  3K-Verwaltung in das entsprechende Feld im BDL-Programm eingetragen
                  werden.
                </span>
                <img src="./images/2kaccountoverview.png" style="width: 400px" />
                <img src="./images/2keinstellungen_2.png" style="width: 400px" />
              </ul>
              <ul class="flex flex-column align-items-center justify-content-center">
                <span style="display: block">
                  Nach dem Klick auf den "Einstellungen übernehmen"-Button erscheint ein
                  Hinweis-Dialog ob die Verbindung funktioniert hat. Er nennt den Namen,
                  unter dem Ihr Verein in 3K geführt wird - so sehen Sie, dass der
                  richtige Mandanten-Key eingetragen ist.
                </span>
                <img src="./images/2keinstellungen_valid.png" style="width: 400px" />
                <span style="display: block">
                  Hat Ihr Verein in 3K noch kein Spiel angelegt, wird der Key trotzdem
                  übernommen. Die Verbindung zu 3K stellt das BDL-Programm dann von
                  selbst her, sobald es in 3K das erste Spiel gibt.
                </span>
                <span style="display: block">
                  Falls die Übernahme nicht erfolgreich war, nennt der Dialog den Grund:
                  Entweder ist der 3K-Mandanten-Key in 3K nicht vergeben - dann prüfen
                  Sie ihn bitte in der Kontoübersicht -, oder 3K ist gerade nicht
                  erreichbar - dann versuchen Sie es bitte später noch einmal. Bei Bedarf
                  wenden Sie sich an den Programmierer des BDL-Programms.
                </span>
                <img src="./images/2keinstellungen_invalid.png" style="width: 400px" />
              </ul>
            </ol>
          </h4>
        </div>
      </Panel>
      <Panel
        ref="panel2kSpieler"
        header="Wie bekomme ich die Spieler der gegnerischen Mannschaften nach 3K"
      >
        <div class="flex flex-column align-items-center justify-content-center">
          <ol style="text-align: left">
            <li style="margin-bottom: 10px">
              Im Menü auf den Bereich "Weiteres", dann auf 3K-Einstellungen klicken.
            </li>
            <li style="margin-bottom: 10px">
              Unterhalb des 3K-Mandanten-Keys steht die Zeile "Alle Gegner". Das
              <Button
                style="margin: 2px 2px; vertical-align: middle"
                class="p-button-sm p-button-outlined"
                icon="pi pi-download"
              />
              daneben lädt eine CSV-Datei mit allen gemeldeten Spielern der
              Mannschaften, die in dieser Saison bei Ihnen zu Gast sind — die Spalte
              "Mannschaft" trennt sie. Mannschaften, bei denen Sie nur auswärts
              antreten, stehen nicht darin, und Pokalgegner auch nicht.
            </li>
            <li style="margin-bottom: 10px">
              Darunter steht jeder dieser Gegner noch einmal einzeln, in der
              Reihenfolge Ihrer Heimspiele und mit Spieltag und Termin. Der gleiche
              Knopf daneben lädt nur die Spieler dieser einen Mannschaft —
              praktisch, wenn Sie kurz vor dem Heimspiel nur den nächsten Gegner
              brauchen.
            </li>
            <li style="margin-bottom: 10px">
              Diese Datei können Sie in der 3K-Verwaltung über den Spieler-Import
              einlesen, damit Sie die Namen der Gegner beim Scoring nicht abtippen
              müssen.
            </li>
          </ol>
          <Message severity="warn" :closable="false" style="text-align: left">
            3K übernimmt den Mannschaftsnamen aus der Datei nur als Freitext. Die
            Zuordnung eines Spielers zu einer Mannschaft kann der Import nicht
            setzen — die muss in 3K von Hand nachgezogen werden. Der importierte
            Mannschaftsname am Spieler sagt Ihnen dabei, wohin er gehört.
          </Message>
          <span style="text-align: left; margin-top: 10px">
            Die Liste gibt den Stand der Meldungen zum Zeitpunkt des Downloads
            wieder. Melden Gegner später Spieler nach, laden Sie die Datei einfach
            erneut herunter.
          </span>
        </div>
      </Panel>
      <Panel
        ref="panel15"
        header="Wie kann ich mein Spielergebnis von 3K in das BDL-Programm importieren"
      >
        <div class="flex flex-column align-items-center justify-content-center">
          <h4>
            <ol style="text-align: left">
              <ul class="flex flex-column align-items-center justify-content-center">
                <span style="display: block"
                  >Öffnen Sie das Spiel in der Spieltagsübersicht mit
                  <Button
                    style="margin: 2px 2px; vertical-align: middle"
                    icon="pi pi-pencil"
                    v-tooltip.top="'Editieren'"
                    class="p-button-rounded p-button-warning mb2"
                  />
                  oder
                  <Button
                    style="margin: 2px 2px; vertical-align: middle"
                    icon="pi pi-eye"
                    v-tooltip.top="'Details'"
                    class="p-button-rounded p-button-success mb2"
                  />
                  und klicken Sie anschließend auf den Reiter 3K-Import.
                </span>
                <img src="./images/2kimportmenu.png" style="width: 200px" />
                <Message
                  severity="warn"
                  :closable="false"
                  style="margin: 0px; margin-bottom: 10px"
                >
                  Der Import kann nur durchgeführt werden, wenn der 3K-Mandanten-Key
                  eingetragen ist und das Spiel nicht bereits abgeschlossen worden ist.
                  Sonst ist der 3K-Import-Reiter nicht sichtbar.
                </Message>
              </ul>
              <ul class="flex flex-column align-items-center justify-content-center">
                <span style="display: block">
                  Die Spiele aus 3K werden geladen und das passende Spiel kann
                  anschließend über das Auswahlfeld gewählt werden. Die Spiele sind nach
                  Datum sortiert, das passende Spiel sollte also weit oben zu finden sein.
                </span>
                <img src="./images/2kimportchoose.png" style="width: 400px" />
              </ul>
              <Message
                severity="warn"
                :closable="false"
                style="margin: 0px; margin-bottom: 10px"
              >
                Achtung: Es werden nur Spiele in der Auswahl angezeigt, die nicht bereits
                archiviert sind und die einen eingetragenen Spielplan haben.
              </Message>
              <ul class="flex flex-column align-items-center justify-content-center">
                <span style="display: block">
                  Nach der Auswahl kann der Import über den Button
                  <Button
                    label="Manuellen Import starten"
                    style="margin-bottom: 4px; width: 300px; vertical-align: middle"
                  />
                  gestartet werden.
                </span>

                <span style="display: block">
                  Nach dem Import springt das Programm zur Spielübersicht und der Import
                  kann überprüft werden. Im 3K-Bereich des Spiels ist außerdem eim
                  Protokoll des letzten Import für 14 Tage hinterlegt.
                </span>
              </ul>
            </ol>
          </h4>
          <Message
            severity="info"
            :closable="false"
            style="margin: 0px; margin-bottom: 10px"
          >
            Der Import kann beliebig oft ausgeführt werden, auch während des Spiels.
          </Message>
        </div>
      </Panel>
      <Panel
        ref="panelApi"
        header="Wie hole ich mir Daten über die offizielle Schnittstelle (API) für eigene Auswertungen?"
      >
        <div class="flex flex-column align-items-center justify-content-center">
          <span style="text-align: left"
            >Die Badische Dartliga stellt eine offizielle, <b>lesende</b> Schnittstelle
            bereit. Damit kannst du Spielpläne, Tabellen und Statistiken selbst
            auswerten – zum Beispiel in Excel, einem Skript oder einer eigenen
            Vereinsseite. Geantwortet wird immer mit JSON; geschrieben werden kann über
            die Schnittstelle nichts.</span
          >

          <h3>Dokumentation</h3>
          <span style="text-align: left"
            >Alle Endpunkte inklusive Parametern und Beispielantworten stehen in der
            <a :href="apiDocsUrl" target="_blank" rel="noopener"
              >Swagger-Dokumentation</a
            >
            unter <b>{{ apiDocsUrl }}</b
            >. Dort kannst du die Aufrufe nach Eingabe deines Schlüssels auch direkt
            ausprobieren.</span
          >
          <a :href="apiDocsUrl" target="_blank" rel="noopener" style="margin: 12px 0px">
            <Button label="Swagger-Dokumentation öffnen" icon="pi pi-external-link" />
          </a>

          <h3>API-Schlüssel</h3>
          <span style="text-align: left"
            >Jede Anfrage braucht einen persönlichen Schlüssel. Den gibt es
            ausschließlich über den Programmierer der Liga – frag einfach über dein
            Postfach nach (siehe
            <a class="fakeLink" @click="findAndScrollTo('panelPostfach')"
              >„Wie arbeite ich mit meinem Postfach?"</a
            >) und nenne dabei kurz, wofür du die Daten nutzen möchtest. Der Schlüssel
            wird bei jeder Anfrage im Kopfzeilen-Feld
            <b>X-API-Key</b>
            mitgeschickt.</span
          >
          <Message severity="warn" :closable="false" style="margin: 10px 0px">
            Behandle den Schlüssel wie ein Passwort: nicht weitergeben und nicht in
            öffentlichem Programmcode oder auf einer Webseite hinterlegen. Er lässt sich
            jederzeit sperren. Ohne gültigen Schlüssel antwortet die Schnittstelle mit
            <b>401</b> und dem Hinweis „Diese Schnittstelle benötigt einen gültigen
            API-Schlüssel im Header X-API-Key.".
          </Message>

          <h3>Grundaufbau</h3>
          <table>
            <tr style="text-align: left">
              <td style="border-bottom: 1px solid #ddd; padding: 4px 8px">
                <b>/api/v1</b>
              </td>
              <td style="border-bottom: 1px solid #ddd; padding: 4px 8px">
                Einstiegsdokument – listet die verfügbaren Bereiche auf.
              </td>
            </tr>
            <tr style="text-align: left">
              <td style="border-bottom: 1px solid #ddd; padding: 4px 8px">Saison</td>
              <td style="border-bottom: 1px solid #ddd; padding: 4px 8px">
                Als Kürzel <b>JJ-JJ</b> (z.&nbsp;B. 25-26) oder als Schlüsselwort
                <b>current</b> für die laufende Saison.
              </td>
            </tr>
            <tr style="text-align: left">
              <td style="border-bottom: 1px solid #ddd; padding: 4px 8px">Liga</td>
              <td style="border-bottom: 1px solid #ddd; padding: 4px 8px">
                Über das kleingeschriebene Kürzel der Liga, immer innerhalb einer Saison.
              </td>
            </tr>
            <tr style="text-align: left">
              <td style="border-bottom: 1px solid #ddd; padding: 4px 8px">Antwort</td>
              <td style="border-bottom: 1px solid #ddd; padding: 4px 8px">
                Immer nach dem gleichen Muster: <b>data</b> enthält die Nutzdaten,
                <b>meta</b> die Seiteninformationen und <b>links</b> die
                Weiterverweise.
              </td>
            </tr>
          </table>

          <h3>Beispiel: Highlights meiner Mannschaft in der laufenden Saison</h3>
          <ol style="text-align: left">
            <li>
              <b>Mannschaft suchen</b>, um ihre Nummer und das Ligakürzel zu erfahren:
              <pre :style="codeStyle">
curl -H "X-API-Key: DEIN_SCHLUESSEL" \
  "{{ apiBaseUrl }}/api/v1/teams?season=current&amp;q=Jacky"</pre
              >
              In der Antwort stehen unter <b>data</b> die Mannschaft mit ihrer
              <b>id</b> und unter <b>leagues</b> das Ligakürzel als <b>key</b>.
            </li>
            <li>
              <b>Spielerstatistik der Liga abrufen</b> und dabei auf die eigene
              Mannschaft einschränken:
              <pre :style="codeStyle">
curl -H "X-API-Key: DEIN_SCHLUESSEL" \
  "{{ apiBaseUrl }}/api/v1/seasons/current/leagues/bzo1/statistics/players?team=1058&amp;sort=-highScores"</pre
              >
              <b>team</b> filtert auf die eigene Mannschaft, <b>sort=-highScores</b>
              sortiert absteigend nach den 171ern und höher. Genauso möglich:
              <b>-highFinishes</b> oder <b>-shortLegs</b>.
            </li>
            <li>
              <b>Antwort auswerten</b> – pro Spieler kommen die drei Highlight-Blöcke
              zurück:
              <pre :style="codeStyle">
{
  "data": [
    {
      "player": { "id": 4711, "name": "Max Mustermann" },
      "team":   { "id": 1058, "name": "501 Jacky Darts I" },
      "highScores":   { "total": 7, "best": 180, "count180": 3,
                        "byValue": { "171": 4, "180": 3 } },
      "highFinishes": { "total": 2, "best": 132,
                        "byValue": { "104": 1, "132": 1 } },
      "shortLegs":    { "total": 1, "best": 15,
                        "byValue": { "15": 1 } }
    }
  ],
  "meta": { "page": 0, "size": 25, "total": 8 }
}</pre
              >
            </li>
          </ol>
          <table>
            <tr style="text-align: left">
              <td style="border-bottom: 1px solid #ddd; padding: 4px 8px">
                <b>total</b>
              </td>
              <td style="border-bottom: 1px solid #ddd; padding: 4px 8px">
                Anzahl der Vorkommen insgesamt.
              </td>
            </tr>
            <tr style="text-align: left">
              <td style="border-bottom: 1px solid #ddd; padding: 4px 8px"><b>best</b></td>
              <td style="border-bottom: 1px solid #ddd; padding: 4px 8px">
                Bei HighScores und HighFinishes der höchste Wert, bei ShortLegs die
                niedrigste Dartzahl.
              </td>
            </tr>
            <tr style="text-align: left">
              <td style="border-bottom: 1px solid #ddd; padding: 4px 8px">
                <b>count180</b>
              </td>
              <td style="border-bottom: 1px solid #ddd; padding: 4px 8px">
                Anzahl der 180er – gibt es nur bei den HighScores.
              </td>
            </tr>
            <tr style="text-align: left">
              <td style="border-bottom: 1px solid #ddd; padding: 4px 8px">
                <b>byValue</b>
              </td>
              <td style="border-bottom: 1px solid #ddd; padding: 4px 8px">
                Aufschlüsselung, wie oft welcher Wert geworfen wurde.
              </td>
            </tr>
          </table>
          <Message severity="info" :closable="false" style="margin: 10px 0px">
            Die 180er stammen ausschließlich aus den Highscores der Spielberichte –
            trag sie also dort sauber ein, siehe
            <a class="fakeLink" @click="findAndScrollTo('panelHighlights')"
              >„Wie trage ich Highlights ein?"</a
            >. Die Anzahl der Abfragen pro Schlüssel ist begrenzt; wie viele noch übrig
            sind, steht in den Antwort-Kopfzeilen <b>X-RateLimit-Remaining</b> und
            <b>X-RateLimit-Reset</b>.
          </Message>
        </div>
      </Panel>
    </div>
    <ScrollTop :threshold="200" />
  </div>
</template>

<script>
import { useMenuService } from "../../services/MenuService/UseMenuService";
import Panel from "primevue/panel";
import ScrollTop from "primevue/scrolltop";
import Button from "primevue/button";
import Message from "primevue/message";
import Paginator from "primevue/paginator";
import Calendar from "primevue/calendar";
import TabMenu from "primevue/tabmenu";
export default {
  name: "HelpMain",
  components: {
    Panel,
    ScrollTop,
    Button,
    Message,
    Paginator,
    Calendar,
    TabMenu,
  },
  created() {
    this.updateMainMenu();
    this.updatePanelRefs();
  },
  updated() {
    this.updateMainMenu();
    this.updatePanelRefs();
  },
  mounted() {
    this.updatePanelRefs();
  },
  computed: {
    loggedIn() {
      var user = localStorage.getItem("user");
      return user && user != null;
    },
    apiBaseUrl() {
      return window.location.origin;
    },
    apiDocsUrl() {
      return window.location.origin + "/api/v1/docs";
    },
    codeStyle() {
      return {
        background: "#f5f5f5",
        border: "1px solid #ddd",
        borderRadius: "4px",
        padding: "10px",
        margin: "8px 0px",
        overflowX: "auto",
        whiteSpace: "pre",
        fontSize: "13px",
      };
    },
    currentDate() {
      var date = new Date();
      date.setHours(20);
      date.setMinutes(0);
      date.setSeconds(0);
      return date;
    },
    teamAdminMenuItems() {
      return [
        {
          index: 0,
          name: "postfach",
          label: "Postfach",
          icon: "pi pi-fw pi-envelope",
          style: "padding: 0px 1px",
        },
      ];
    },
  },
  data() {
    return {
      panelRefs: [],
      alibiIndex: 10,
    };
  },
  props: {},
  methods: {
    updateMainMenu() {
      var menuService = useMenuService();
      menuService.setSidebarVisisble(false);
      menuService.setMainMenuItemNames([
        {
          name: "return",
          command: () => {
            if (window.history.length > 1) {
              this.$router.go(-1);
            } else {
              this.$router.push("/");
            }
          },
        },
      ]);
    },
    updatePanelRefs() {
      if (this.$refs) {
        this.panelRefs = this.$refs;
        if (!this.loggedIn) {
          delete this.panelRefs.panel1;
        }
      }
    },
    scrollTo(ref) {
      if (ref && ref.$el) {
        ref.$el.scrollIntoView({ behavior: "smooth" });
      }
    },
    findAndScrollTo(refName) {
      var foundRef = this.panelRefs[refName];
      if (foundRef) {
        this.scrollTo(foundRef);
      }
    },
    routeToInbox() {
      this.$router.push({ path: "/postfach", query: { neu: "1" } });
    },
  },
};
</script>

<style lang="css">
.fakeLink {
  cursor: pointer;
  text-decoration: underline;
}
.p-overlay-badge .p-badge {
  transform: translate(20%, -20%) !important;
}
</style>
